module.exports = __webpack_public_path__ + "static/media/change_02.6fc1a598.jpg";